export default {
  type: Object.freeze({ROOT: 'root', ADMIN: 'admin', OPERATOR: 'operator', SYS_ADMIN: 'sys_admin'}),
  category: Object.freeze({
    USUAL: 'usual', SERVICE: 'service', USUAL_LABEL: 'Роли', SERVICE_LABEL: 'Сервисные роли'
  }),
  statementOfAccount: {
    category: Object.freeze({ACCOUNTS: 'accounts', ACTS: 'acts', ACCOUNTS_LABEL: 'Счета', ACTS_LABEL: 'Акты'})
  }
}
